import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import DateTimePicker from 'react-datetime-picker'
import Multiselect from 'multiselect-react-dropdown'
import { isEmpty, masterAndChildIntersection } from '../../utils/helper'
import moment from 'moment'
import { CustomDescriptionBox } from '../../../components'
import { AsyncPaginate } from 'react-select-async-paginate'
import useAxios from 'axios-hooks'
import { SUBSCRIBER_API } from 'src/views/utils/urls'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'

const DiscountCreationModal = ({
  openModal,
  onCancel,
  type,
  subscription,
  data,
  createCallback,
  updateCallback,
  affiliate = null,
}) => {
  const { setLoader, loader } = useContext(AppContext)

  const userSpecific = type === 'udisc' || type === 'uvouch'
  const discountCodeShow = type === 'vouch' || type === 'uvouch'

  const [discountName, setDiscountName] = useState('')
  const [description, setDescription] = useState('')

  const [applicableSubscriptions, setApplicableSubscriptions] = useState([])
  const [selectedEditSubs, setSelectedEditSubs] = useState([])

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState('')

  const [maxValue, setMaxValue] = useState('')
  const [noTimesRedeemable, setNoTimesRedeemable] = useState('')

  const [value, setValue] = useState('')
  const [valueType, setValueType] = useState('percentage')

  const [discountCode, setDiscountCode] = useState('')

  const [applicableUsers, setApplicableUsers] = useState([])

  const [isUserVisible, setIsUserVisible] = useState(true)

  const [errorData, setErrorData] = useState({})

  const editFlag = !isEmpty(data)

  const [{ loading: subscriberListLoading }, subscriberListCall] = useAxios(
    {
      url: `${SUBSCRIBER_API}/list?page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(subscriberListLoading)
  }, [subscriberListLoading])

  useEffect(() => {
    handleEdit()
  }, [data])

  const handleEdit = () => {
    if (!isEmpty(data)) {
      setDiscountName(data.name)
      setDescription(data.description)
      setStartDate(new Date(data.start_date))
      setEndDate(new Date(data.end_date))
      setMaxValue(data.max_value)
      setNoTimesRedeemable(data.no_times_redeemable)
      setValue(data.value)
      setValueType(data.value_type)
      setDiscountCode(data.discount_code)
      setIsUserVisible(data.is_user_visible)

      let tempSub = []
      subscription.forEach((ele) => {
        let subIndex = data.applicable_subscriptions.findIndex((e) => e === ele._id)
        if (subIndex > -1) {
          tempSub.push(ele)
        }
      })
      let intersectionData = masterAndChildIntersection(subscription, tempSub)
      setSelectedEditSubs(intersectionData)
      setApplicableSubscriptions(intersectionData.map((obj) => obj._id))

      if (userSpecific && !isEmpty(data?.subscriber_id)) {
        setApplicableUsers(
          data.subscriber_id.map((info) => ({
            ...info,
            label: `${info.name} (${info.email_id})`,
            value: info.subscriber_id,
            _id: info.subscriber_id,
          })),
        )
      }
    }
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target
    let temp = errorData
    temp[`${name}`] = ''
    setErrorData({ ...temp })
    func(value)
  }
  const handleDateChange = (err, value, func) => {
    let temp = errorData
    temp[`${err}`] = ''
    setErrorData({ ...temp })
    func(value)
  }

  const handleSelectSubscription = (info, type) => {
    setErrorData({ ...errorData, applicableSubscriptions: '' })
    let temp = applicableSubscriptions
    if (type === 'add' && temp.indexOf(info._id) === -1) {
      temp.push(info._id)
    } else if (type === 'remove') {
      temp = temp.filter((id) => id !== info._id)
    }
    setApplicableSubscriptions(temp)
  }

  // const handleSelectUsers = (info, type) => {
  //   setErrorData({ ...errorData, applicableUsers: '' })
  //   let temp = applicableUsers
  //   if (type === 'add' && temp.indexOf(info._id) === -1) {
  //     temp.push(info._id)
  //   } else if (type === 'remove') {
  //     temp = temp.filter((id) => id !== info._id)
  //   }
  //   setApplicableUsers(temp)
  // }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (discountName.trim().length === 0) {
      isFormValid = false
      temp.discountName = 'Name cannot be Empty!'
    }
    if (isEmpty(applicableSubscriptions)) {
      isFormValid = false
      temp.applicableSubscriptions = 'Select a Plan!'
    }
    if (!startDate) {
      isFormValid = false
      temp.startDate = 'Select Start Date!'
    }
    if (!endDate) {
      isFormValid = false
      temp.endDate = 'Select End Date!'
    }
    if (!maxValue || maxValue < 0) {
      isFormValid = false
      temp.maxValue = 'Enter a Valid Value!'
    }
    if (!noTimesRedeemable || noTimesRedeemable < 0) {
      isFormValid = false
      temp.noTimesRedeemable = 'Enter a Valid Value!'
    }

    if (!value || value < 0) {
      isFormValid = false
      temp.value = 'Enter a Valid Value!'
    }

    if (valueType === 'percentage' && (!value || value > 100 || value < 0)) {
      isFormValid = false
      temp.value = 'Enter a Valid Value!'
    }

    if (discountCodeShow && discountCode.trim().length === 0) {
      isFormValid = false
      temp.discountCode = 'Code cannot be Empty!'
    }
    if (userSpecific && isEmpty(applicableUsers)) {
      isFormValid = false
      temp.applicableUsers = 'Select Users!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = () => {
    if (validateInfo()) {
      let payload = {
        name: discountName,
        description: description,
        applicable_subscriptions: applicableSubscriptions,
        start_date: moment(startDate).format('yyyy-MM-DD'),
        end_date: moment(endDate).format('yyyy-MM-DD'),
        max_value: maxValue,
        value: value,
        value_type: valueType,
        no_times_redeemable: noTimesRedeemable,
        discount_code: discountCode,
        subscriber_id: applicableUsers.map((info) => info._id),
        is_user_visible: isUserVisible,
        is_user_specific: userSpecific,
        affiliate,
      }

      editFlag ? updateCallback(payload, data._id) : createCallback(payload)
    }
  }

  async function loadOptions(search, loadedOptions, { page }) {
    const response = await subscriberListCall({
      params: {
        page: page,
        search_text: search,
      },
    })

    const responseJSON = {
      results: response.data.data.map((info) => ({
        ...info,
        label: `${info.name} (${info.email_id})`,
        value: info._id,
      })),
      hasMore: response.data.total > page * 20,
    }

    return {
      options: responseJSON.results,
      hasMore: responseJSON.hasMore,
      additional: {
        page: page + 1,
      },
    }
  }
  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {editFlag ? `Edit` : `Add`} {userSpecific ? ` User ` : ``}
            {discountCodeShow ? `Voucher` : `Discount`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <div className="mb-">
            <CFormLabel>Name*</CFormLabel>
            <CCol lg="12">
              <CFormInput
                type="text"
                value={discountName}
                name="discountName"
                onChange={(e) => handleChange(e, setDiscountName)}
              />
              <div className="message-text error-message">
                <p>{errorData.discountName}</p>
              </div>
            </CCol>
          </div>
          <div className="mt-3">
            <CustomDescriptionBox
              title="Description"
              rows={2}
              value={description}
              onChange={setDescription}
            />
          </div>
          <div className="mt-3">
            <CFormLabel>Select Plans*</CFormLabel>
            <CRow>
              <CCol lg="12">
                <Multiselect
                  options={subscription.filter((item) => item.status)} // Options to display in the dropdown
                  selectedValues={editFlag ? selectedEditSubs : null}
                  color="red"
                  style={{
                    chips: {
                      background: 'blue',
                    },
                    searchBox: {
                      background: 'white',
                    },
                  }}
                  showCheckbox="true"
                  onSelect={(e, info) => handleSelectSubscription(info, 'add')}
                  onRemove={(e, info) => handleSelectSubscription(info, 'remove')}
                  displayValue="displayName"
                />
                <div className="message-text error-message">
                  <p>{errorData.applicableSubscriptions}</p>
                </div>
              </CCol>
            </CRow>
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <div style={{ width: '39%' }}>
              <CFormLabel>Applicable From*</CFormLabel>
              <CCol>
                <DateTimePicker
                  className="shadow-effect w-100"
                  onChange={(value) => handleDateChange('startDate', value, setStartDate)}
                  name="startDate"
                  value={startDate}
                  disableClock
                  format="   dd   /   MM     /   yyyy"
                  minDate={new Date()}
                />
                <div className="message-text error-message">
                  <p>{errorData.startDate}</p>
                </div>
              </CCol>
            </div>
            <div style={{ width: '39%' }} className="">
              <CFormLabel className="">Valid Till*</CFormLabel>
              <CCol>
                <DateTimePicker
                  className="shadow-effect w-100"
                  onChange={(value) => handleDateChange('endDate', value, setEndDate)}
                  name="endDate"
                  value={endDate}
                  disableClock
                  format="   dd    /    MM     /     yyyy"
                  minDate={startDate}
                />
                <div className="message-text error-message">
                  <p>{errorData.endDate}</p>
                </div>
              </CCol>
            </div>
          </div>
          <CRow className="mt-3">
            <CCol lg={4}>
              <CFormLabel>Value*</CFormLabel>
              <CFormInput
                type="number"
                value={value}
                min="0"
                name="value"
                onChange={(e) => handleChange(e, setValue)}
              />
              <div className="message-text error-message">
                <p>{errorData.value}</p>
              </div>
            </CCol>
            <CCol lg="4">
              <CFormLabel>Value Type*</CFormLabel>
              <CFormSelect
                value={valueType}
                name="valueType"
                disabled={editFlag}
                onChange={(e) => handleChange(e, setValueType)}
                placeholder="valueType"
              >
                <option value="percentage">Percentage</option>
                <option value="value">Value</option>
              </CFormSelect>
            </CCol>
            <CCol lg={4}>
              <CFormLabel>Max Value*</CFormLabel>
              <CFormInput
                type="number"
                value={maxValue}
                min="0"
                name="maxValue"
                onChange={(e) => handleChange(e, setMaxValue)}
              />
              <div className="message-text error-message">
                <p>{errorData.maxValue}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3 align-items-center">
            <CCol lg="4">
              <CFormCheck
                id="flexCheckDefault"
                label="Visible to User"
                checked={isUserVisible}
                onChange={() => setIsUserVisible(!isUserVisible)}
              />
            </CCol>
            <CCol lg={4}>
              <CFormLabel># Times Redeemable*</CFormLabel>
              <CFormInput
                type="number"
                value={noTimesRedeemable}
                min="0"
                name="noTimesRedeemable"
                onChange={(e) => handleChange(e, setNoTimesRedeemable)}
              />
              <div className="message-text error-message">
                <p>{errorData.noTimesRedeemable}</p>
              </div>
            </CCol>
            {discountCodeShow && (
              <CCol lg={4}>
                <CFormLabel>Discount Code*</CFormLabel>
                <CFormInput
                  type="text"
                  value={discountCode}
                  name="discountCode"
                  onChange={(e) => handleChange(e, setDiscountCode)}
                />
                <div className="message-text error-message">
                  <p>{errorData.discountCode}</p>
                </div>
              </CCol>
            )}
          </CRow>

          {/* <div className="mt-3">
            <CCol xs="3">
              <CFormCheck
                id="flexCheckDefault"
                label="For New USer"
                defaultChecked={forNewUser}
                onChange={() => setForNewUser(!forNewUser)}
              />
            </CCol>
          </div> */}
          {userSpecific && (
            <div className="mt-3">
              <CFormLabel>Select Users*</CFormLabel>
              <CRow>
                <CCol lg="12">
                  <AsyncPaginate
                    value={applicableUsers}
                    loadOptions={loadOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    onChange={setApplicableUsers}
                    additional={{
                      page: 1,
                    }}
                  />

                  <div className="message-text error-message">
                    <p>{errorData.applicableUsers}</p>
                  </div>
                </CCol>
              </CRow>
            </div>
          )}
          {editFlag && (
            <p className="mt-3 italic">
              *Value type is non-editable while editing if needed create a new
              {discountCodeShow ? ' voucher' : ' discount'}
            </p>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleCreate}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default DiscountCreationModal
